var App = App || {};

App.Articles = (function ($) {
    "use strict";

    function init() {

        $("section.articles").each(function () {
            var Button = $(this).find(".articles-more .articles-more-button > button");

            Button.click(function () {
                $(this).parent(".articles-more-button").hide().siblings(".articles-more-hidden").slideDown(300);
            });
        });

    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Articles.init();
});